// extracted by mini-css-extract-plugin
export var actionIcon = "_pc-0";